<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <a class="d-none d-sm-block"><img class="img-avatar avatar img-fluid rounded-circle mr-1" v-bind:src="this.loginState.user.image" v-if="this.loginState.user && this.loginState.user.image" 
         alt="avatar" />{{this.loginState.user ? this.loginState.user.name : ""}}</a>
      <a class="d-block d-sm-none"><img class="img-avatar avatar img-fluid rounded-circle mr-1" v-bind:src="this.loginState.user.image" v-if="this.loginState.user && this.loginState.user.image" 
         alt="avatar" /></a>
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>Konto</strong></b-dropdown-header>
      <b-dropdown-item disabled><i class="fa fa-bell-o" /> Releaser
        <b-badge variant="success">{{ releaseCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item disabled><i class="fa fa-comments" /> Meddelanden
        <b-badge variant="success">{{ itemsCount }}</b-badge>
      </b-dropdown-item>

      <b-dropdown-item v-on:click="profile()"><i class="fa fa-user" /> Profil</b-dropdown-item>
      <b-dropdown-item disabled><i class="fa fa-wrench" /> Inställningar</b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item  v-on:click="logout()" ><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import { globalStore, } from "../shared/helpers"
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data()  {
    return { 
      itemsCount: 0,
      releaseCount: 0,
      commentsCount: 0,
    }
  },

  methods: {
    logout() {
      this.loginState.logout();
      this.$router.push('/pages/login');
    },
    profile() {
      this.$router.push('/administration/users/' + this.loginState.user.id);
    }
  }
}
</script>

<style scoped>
  .testbild{
    width: 45px;
  }

</style>
